import { render, staticRenderFns } from "./ComponenteSuperior.vue?vue&type=template&id=8d9b38a6"
import script from "./ComponenteSuperior.vue?vue&type=script&lang=js"
export * from "./ComponenteSuperior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports